import { Component, Input, OnInit, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService, MetadataService, ExpressionFilter, ExpressionRule, Operator, Condition } from '../../../ubi-core/ubi-core.module';

import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { UbiFilterService } from '../../../theme';

import { Page } from '../../model/page';
import { saveAs } from 'file-saver';

@Component({
  selector: 'ubi-dynamic-grid',
  templateUrl: './dynamic-grid.component.html',
  styleUrls: ['./dynamic-grid.component.scss']
})
export class DynamicGridComponent implements OnInit {

  @Input()
  entity: string;

  @Input()
  navigateUrl: string;

  @Input()
  filters: any;

  @Input()
  filter: ExpressionFilter;

  @Input()
  options = { sortType: 'single', advancedSearch: true };

  @Output()
  onDataLoaded = new EventEmitter<any>();

  @ViewChild('filterTmpl') filterTmpl: TemplateRef<any>;

  protected lista: Array<any> = new Array<any>();
  protected page = new Page();
  protected loading = false;
  protected filtersQB = [];
  protected filterNL = '';
  protected filterAdvanced = true;

  protected columns = [
    { prop: 'Id', name: 'Id' }
  ]; // Estas colunas serão apresentada por omissão, caso não exista metadata para a entidade

  constructor(protected baseservice: ApiService, protected metadataservice: MetadataService,
    protected router: Router, protected route: ActivatedRoute, protected modalService: NgbModal,
    protected filterservice: UbiFilterService) {
  }

  ngOnInit() {
    const entityFromRoute = this.route.snapshot.data['entity'];
    const navigateUrlFromRoute = this.route.snapshot.data['navigateUrl'];
    const optionsRoute = this.route.snapshot.data['options'];

    // caso existam os dois o @Input sobrepõe-se ao data do Router
    if (entityFromRoute !== null && entityFromRoute !== undefined
      && (this.entity === null || this.entity === undefined)) {
      this.entity = entityFromRoute;
    }

    // caso existam os dois o @Input sobrepõe-se ao data do Router
    if (navigateUrlFromRoute !== null && navigateUrlFromRoute !== undefined
      && (this.navigateUrl === null || this.navigateUrl === undefined)) {
      this.navigateUrl = navigateUrlFromRoute;
    }

    // caso existam os dois o @Input sobrepõe-se ao data do Router
    if (optionsRoute !== null && optionsRoute !== undefined) {
      this.options = optionsRoute;
    }

    this.baseservice.setEntity(this.entity);
    this.metadataservice.setEntity(this.entity);

    this.getMetadata();
    this.getFiltersQB();
    this.getFilters();
    this.getInitialData();
  }

  /**
   * Get data on onInit
   *
   * This could be override
   */
  protected getInitialData() {
    this.getPage({ offset: 0 }, this.filter);
  }

  /**
   * Get metadata on onInit
   *
   * This could be override
   */
  protected getMetadata() {
    this.metadataservice.getMetadataGrid()
      .subscribe(return_value => { this.columns = return_value; this.columns = [...this.columns]; },
      error => console.log('Error fetching Metadata: ' + error));
  }

  /**
  * Get filters on onInit
  *
  * This could be override
  */
  protected getFilters() {
    this.metadataservice.getFilters()
      .subscribe(return_value => { this.filters = return_value; },
      error => console.log('Error fetching Filters: ' + error));
  }

  protected getFiltersQB() {
    this.metadataservice.getFiltersQB()
      .subscribe(return_value => { this.filtersQB = return_value; },
      error => console.log('Error fetching QueryBuilder Filters : ' + error));
  }

  /**
   * Open detail view of selected record
   *
   */
  public openDetail({ selected }) {
    if (this.navigateUrl !== null && this.navigateUrl !== undefined) {
      this.router.navigateByUrl(this.navigateUrl + '/' + selected[0].Id);
    }
  }

  /**
   * Open new record view of current entity
   *
   */
  public new(event) {
    if (this.navigateUrl !== null && this.navigateUrl !== undefined) {
      this.router.navigateByUrl(this.navigateUrl);
    }
  }

  /**
   * Populate the table with new data based on the page number
   * @param pageInfo The page to select
   */
  getPage(pageInfo, filter, method = null) {

    if (filter === undefined && this.filter !== null) {
      filter = this.filter;
    }

    this.loading = true;
    this.page.pageNumber = pageInfo.offset + 1;

    this.baseservice.getPage(this.page, filter, method)
      .subscribe(return_value => {
        //console.log(return_value.data);
        this.lista = return_value.data;
        if (return_value.paging !== undefined && return_value.paging !== null) {
          this.page.totalElements = return_value.paging.totalCount;
          this.page.totalPages = return_value.paging.pageCount;
        }
        this.loading = false;
        this.onDataLoaded.emit(return_value);
      },
      error => console.log('Error fetching: ' + error));
  }

  /**
   * Populate the table with new data based on sort
   * @param sort Sort information - sort event of ngx-datatable
   */
  sortPage(sort, method) {

    this.loading = true;
    this.page.sorts = sort.sorts;
    this.page.pageNumber = 1;

    this.baseservice.getPage(this.page, this.filter, method)
      .subscribe(return_value => {
        this.lista = return_value.data;
        this.page.totalElements = return_value.paging.totalCount;
        this.page.totalPages = return_value.paging.pageCount;
        this.loading = false;
        this.onDataLoaded.emit(return_value);
      },
      error => console.log('Error fetching: ' + error));

  }

  /**
   * Export entity to Excel format
   *
   */
  public excel() {

    this.baseservice.exportExcel({ offset: 0, pageSize: 100 }, this.filter)
      .subscribe(return_value => {
        saveAs(return_value.blob, return_value.filename);
      },
      error => { console.log('Error exporting Excel ' + this.entity + ' ' + error); }
      );
  }

  /**
   * Filter changed
   */
  protected filterChanged(event) {

    if (typeof event.Filter === 'string') {
      this.filter = JSON.parse(event.Filter);
    } else {
      this.filter = new ExpressionFilter().deserialize(event.Filter);
    }
    this.filterNL = event.Designation;
    this.filterAdvanced = false;

    this.getInitialData();
  }

  /**
   * Erase Filter
   * @param event
   */
  protected eraseFilter(event) {
    this.filter = null;
    this.filterNL = null;
    this.filterAdvanced = true;
    this.getInitialData();
  }

  /**
   * Open modal popup with Advanced Search
   */
  public advancedSearch(event) {

    console.log('filterAdvanced' + this.filterAdvanced);

    if (!this.filterAdvanced) {
      this.filter = null;
    }

    this.modalService.open(this.filterTmpl, { backdrop: 'static', keyboard: false, size: 'lg' }).result.then((result) => {
      if (result === 'Save') {
        this.filter = this.filterservice.getCurrentFilter();
        this.filterNL = this.filterservice.getCurrentFilterNL();
        this.filterAdvanced = true;
        this.getInitialData();

      } else {
        // Não faz nada quando se cancela
      }
    });

  }

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/dynamic-entity/components/dynamic-grid/dynamic-grid.component.ts